<template>
  <time>
    <svg viewBox="0 0 200 200" width="100%" height="100%">
      <circle cx="100" cy="100" r="90" stroke-width="10" stroke-dasharray="1, 46.1" />
    </svg>
    <!-- Clock Hands -->
    <hr class="hand hour" :style="hourStyle" />
    <hr class="hand minute" :style="minuteStyle" />
    <hr class="hand second" :style="secondStyle" />
    <h5>
      {{city.split("/")[1].replace("_", " ")}}&ensp;{{String(hour).padStart(2,'0')}}:{{String(minute).padStart(2,'0')}}
    </h5>
  </time>
</template>

<script setup>
import { ref, onMounted, computed, defineProps } from 'vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Configure Day.js
dayjs.extend(utc);
dayjs.extend(timezone);

// Define props for timezone
const props = defineProps(['city']);

// Reactive references for time values
const hour = ref(0);
const minute = ref(0);
const second = ref(0);
const millisecond = ref(0); // For smoother second hand motion

// Update time every second
const updateTime = () => {
  const now = dayjs().tz(props.city);
  hour.value = now.hour();
  minute.value = now.minute();
  second.value = now.second();
  millisecond.value = now.millisecond(); // Capture milliseconds for smoother animation
};

// Set intervals for time updates
onMounted(() => {
  updateTime();
  setInterval(updateTime, 1000); // Update time every second
});

// Computed styles for clock hands
const hourStyle = computed(() => ({
  transform: `rotate(${hour.value * 30 + minute.value * 0.5}deg)`,
  transformOrigin: 'bottom center',
}));

const minuteStyle = computed(() => ({
  transform: `rotate(${minute.value * 6}deg)`,
  transformOrigin: 'bottom center',
}));

const secondStyle = computed(() => ({
  transform: `rotate(${(second.value * 6) + (millisecond.value / 1000 * 6)}deg)`, // Smooth movement based on milliseconds
  transformOrigin: 'bottom center',
}));
</script>

<style scoped>
h5 {
  position: absolute;
  bottom: -4rem;
  margin: auto;
  text-align: center;
  left: 0;
  right: 0;
}
time {
  --size: 12rem;
  max-width: var(--size);
  max-height: var(--size);
  position: relative;
  aspect-ratio: 1 / 1;
}

svg {
  position: relative;
  top: 0.1rem;
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
}

svg circle {
  fill: transparent;
  stroke: var(--light);
}

hr {
  position: absolute;
  left: 50%;
  background-color: var(--light);
  transform-origin: bottom center;
  border: none;
}

.hand.hour {
  height: 30%;
  width: 2px;
  top: 20%;
}

.hand.minute {
  height: 40%;
  width: 2px;
  top: 10%;
}

.hand.second {
  height: 45%;
  width: 1px;
  background-color: var(--light);
  top: 5%;
}
</style>
